// import staticAnalysis from 'static-analysis'
import { c } from 'erte'
import readDirStructure from '@wrote/read-dir-structure'

module.exports = {
  'c': c,
  'readDirStructure': readDirStructure,
  // 'staticAnalysis': staticAnalysis,
}